module.exports = __webpack_public_path__ + "static/media/nail-polish.9acb397b.svg";